import { ReactNode, useState } from 'react';

import { ErrorContext } from '../hooks';
import { ErrorCode } from '../hooks/ErrorContext';

export function ErrorContextProvider({ children }: { children: ReactNode }) {
  const [globalError, setGlobalError] = useState<ErrorCode | null>(null);

  return <ErrorContext.Provider value={{ globalError, setGlobalError }}>{children}</ErrorContext.Provider>;
}
